var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 305.833,
    height: 305.834,
    viewBox: "0 0 305.833 305.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -25.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 25.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.3,56A13.3,13.3,0,1,1,446,69.3,13.293,13.293,0,0,1,459.3,56Z",
    transform: "translate(-166.762 -36.053)",
    fill: "#2de7a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.649,146A6.649,6.649,0,1,1,446,152.648,6.651,6.651,0,0,1,452.649,146Z",
    transform: "translate(-166.762 -66.217)",
    fill: "#cc9aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,241.006l118.809,11.043h34.7a27.262,27.262,0,0,1,5.292.519l.106-.519a46.548,46.548,0,0,0-8.8-62.676,39.9,39.9,0,0,0-22.745-54.717V105.781a79.782,79.782,0,1,0-159.565,0v28.875a39.9,39.9,0,0,0-26.355,42.005Z",
    transform: "translate(-56.16 -25.999)",
    fill: "#006fc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.764,433.716h-81.8l27.578-90.826L218.169,330h39.891l51.287,23.935Z",
    transform: "translate(-71.902 -127.884)",
    fill: "#03ca8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.891,289.259v27.086a42.385,42.385,0,0,1-39.891,0V289.259Z",
    transform: "translate(-99.732 -114.23)",
    fill: "#ffeee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.763,285.639l37.824,62.6a46.54,46.54,0,0,1-48.96,69.7L77.415,385.606,46.1,333.774Z",
    transform: "translate(-32.736 -113.017)",
    fill: "#53ffe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.379,274.305a46.538,46.538,0,1,1-63.9-15.764,46.531,46.531,0,0,1,63.9,15.764Z",
    transform: "translate(-29.353 -101.683)",
    fill: "#ffdecf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.891,436l6.132,16.621-6.132,16.621H72.621a16.621,16.621,0,1,1,0-33.243Z",
    transform: "translate(-36.054 -163.409)",
    fill: "#ffdecf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.649,36A6.649,6.649,0,1,1,96,42.648,6.651,6.651,0,0,1,102.649,36Z",
    transform: "translate(-49.46 -29.351)",
    fill: "#ffd92c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.946,
    cy: 19.946,
    r: 19.946,
    transform: "translate(6.649 59.837)",
    fill: "#2de7a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.649,216A6.649,6.649,0,1,1,26,222.648,6.651,6.651,0,0,1,32.649,216Z",
    transform: "translate(-26 -89.677)",
    fill: "#ffd92c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.272,339.457a6.649,6.649,0,0,1,3.192-12.909,6.643,6.643,0,0,0,8.045-4.866,6.649,6.649,0,0,1,12.909,3.187,19.936,19.936,0,0,1-24.147,14.588Z",
    transform: "translate(-47.858 -123.402)",
    fill: "#fdc0b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.283,366a27.04,27.04,0,0,1,27.04,27.04v52.743H286V393.039A27.041,27.041,0,0,1,313.04,366Z",
    transform: "translate(-113.138 -139.949)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.973,416A9.973,9.973,0,1,1,366,425.972,9.976,9.976,0,0,1,375.973,416Z",
    transform: "translate(-139.95 -156.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,232.321A46.539,46.539,0,0,1,206,185.781v-46.54h26.594A33.246,33.246,0,0,0,265.837,106a33.246,33.246,0,0,0,33.243,33.243v46.54A46.539,46.539,0,0,1,252.54,232.321Z",
    transform: "translate(-86.326 -52.811)",
    fill: "#ffdecf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.807,237.349a6.649,6.649,0,0,1,9.4-9.4,6.654,6.654,0,0,0,9.4,0,6.649,6.649,0,0,1,9.4,9.4A19.967,19.967,0,0,1,253.807,237.349Z",
    transform: "translate(-101.696 -93.028)",
    fill: "#fdc0b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.621,436a16.621,16.621,0,1,1,0,33.243H116V436Z",
    transform: "translate(-56.163 -163.409)",
    fill: "#ffeee5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiver);
export default __webpack_public_path__ + "static/media/caregiver.8cdeae1335dc24f99a997b68200b5e68.svg";
export { ForwardRef as ReactComponent };